import Scriba from 'react-scriba';

export class Data {

    static _onValidationFormulaire(nomClasse, objetTrav, type) {
        let objet = {
            "nomClasse": nomClasse,
            "objetTrav": objetTrav,
            "type": type
        };

        var url = "api/Fiche/FicheValidationFormulaire";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _verificationSiPerimetreExiste() {
        var url = "api/Perimetre/VerificationSiPerimetreExiste";
        var paramPost = Scriba.fetch().createParameterPost();

        return fetch(url, paramPost).then(response => response.json());
    }

    /**************************************ACTIONS**********************************************************/

    static _renseignementPerimetre = (perimetre) => {
        const objet = { ...perimetre };
        const url = "api/Perimetre/RenseignementPerimetre";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementListeDeESPACEDEVENTE(filtreVersion, facteurNbreEnregistrement, filtreDisponibleTrav, filtreReserveTrav, filtreOptionneTrav, filtreIdNature, filtreIdLotType, filtreEtage, filtreExposition, filtreBudget, filtreBalcon, filtreTerrasse, filtreLoggia, filtreJardin, recherche, tri, pageIndex, filtreStatutOperation, filtreEtapeReservation, filtreInclureOperationsArchivees) {
        let objet = {
            "filtreVersion": filtreVersion,
            "nbreEnreg": facteurNbreEnregistrement,
            "filtreDisponible": filtreDisponibleTrav,
            "filtreReserve": filtreReserveTrav,
            "filtreOptionne": filtreOptionneTrav,
            "filtreIdNature": filtreIdNature,
            "filtreIdLotType": filtreIdLotType,
            "filtreEtage": filtreEtage,
            "filtreExposition": filtreExposition,
            "filtreBudget": filtreBudget,
            "filtreBalcon": filtreBalcon,
            "filtreTerrasse": filtreTerrasse,
            "filtreLoggia": filtreLoggia,
            "filtreJardin": filtreJardin,
            "recherche": recherche,
            "tri": tri,
            "pageIndex": pageIndex,
            "filtreStatutOperation": filtreStatutOperation,
            "filtreEtapeReservation": filtreEtapeReservation,
            "filtreInclureOperationsArchivees": filtreInclureOperationsArchivees,
        };

        var url = "api/Liste/ListeDeESPACEDEVENTE";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementFicheCarouselOperation() {
        var url = "api/Fiche/FicheCarouselOperation";
        var paramPost = Scriba.fetch().createParameterPost();

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementFicheCarouselProgramme() {
        var url = "api/Fiche/FicheCarouselProgramme";
        var paramPost = Scriba.fetch().createParameterPost();

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onEnvoiEmailDocumentsOperation(mail) {

        let objet = { "mail": mail }

        var url = "api/Email/EnvoiEmailDocumentsOperation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementGetUtilisateurConnecte() {

        var url = "api/Get/GetUtilisateurConnecte";
        var paramPost = Scriba.fetch().createParameterPost();

        return fetch(url, paramPost).then(response => response.json());
    }

    static _envoyerEmail(emails, emailsCc, emailsCci, sujet, corps, from) {
        const objet = { emails, emailsCc, emailsCci, sujet, corps, from }
        const url = "api/Email/EnvoiEmail";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _envoyerEmailAuxCompteEtMAJDesTickets(loginsComptesEtIdsTickets, sujet, corps) {
        const objet = { loginsComptesEtIdsTickets, sujet, corps }
        const url = "api/Email/EnvoiEmailAuxComptesEtMAJDesTickets";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onDeconnexion() {
        let objet = {};

        var url = "api/Auth/Deconnexion";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());

    }

    static _chargementDocument(rowGUID) {
        const objet = { rowGUID };
        const url = "api/Download/GetDocument";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementDocumentAide(NomFichier) {

        let objet =
        {
            "NomFichier": NomFichier
        }

        var url = "api/Download/GetDocumentAide";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onGenerationJetonRetour() {
        var url = "api/Auth/GenerationJetonRetour";
        var paramPost = Scriba.fetch().createParameterPost();

        return fetch(url, paramPost).then(response => response.json());

    }

    static _onVerificationJetonAAD(token) {
        let objet = {
            "token": token
        };
        let url = "api/Auth/VerificationJetonAAD";
        let paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onVerificationLoginAAD(identifiant) {
        let objet = {
            "identifiant": identifiant
        };
        let url = "api/Auth/VerificationLoginAAD";
        let paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onVerificationLoginCompte(identifiant) {
        let objet = {
            "identifiant": identifiant
        };
        let url = "api/Auth/VerificationLoginCompte";
        let paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onVerificationJeton(jwt) {
        let objet = {
            "jwt": jwt
        };
        let url = "api/Auth/VerificationJeton";
        let paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onEstIdentifie() {
        let objet = {
        };
        let url = "api/Auth/EstIdentifie";
        let paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onIdentification(login, motDePasse) {
        let objet = {
            "Login": login,
            "MotDePasse": motDePasse
        };
        let url = "api/Auth/Identification";
        let paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onModificationDeMotDePasse(mdp, clef) {
        let objet = {
            "mdp": mdp,
            "clef": clef,
        };

        var url = "api/MajDonnees/ModificationDeMotDePasse";
        var paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    }

    static _onDemandeDeModificationDeMotDePasse(login, email) {
        let objet = {
            "login": login,
            "email": email
        };

        var url = "api/MajDonnees/DemandeDeModificationDeMotDePasse";
        var paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    }

    static _onAzureDevOpsAuthentication() {
        var url = "oauth2/Authorize";
        var paramPost = Scriba.fetch().createParameterPost();

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onRechargementDeMonCompte() {
        let objet = {
        };
        let url = "api/Auth/RechargementDeMonCompte";
        let paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _getListeDesClassesDeLAssembly = () => {
        const url = "api/Liste/ListeDesClassesDeLAssembly";
        const paramPost = Scriba.fetch().createParameterPost();
        return fetch(url, paramPost).then(response => response.json());
    };

    static _getListeDesAttributsDeLaClasse = (nomDeLaClasse) => {
        const objet = { nomDeLaClasse };
        const url = "api/Liste/ListeDesAttributsDeLaClasse";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _getAdresseEmailFromBackOffice = () => {
        const url = "api/Get/GetAdresseEmailFromBackOffice";
        const paramPost = Scriba.fetch().createParameterPost();
        return fetch(url, paramPost).then(response => response.json());
    };

}